import React, { useState } from 'react';
import bemCn from 'bem-cn';
import loadable from '@loadable/component';
import { RouteFormatter } from '../../routes';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import SniffButton from '../sniff-button';
import SvgLocation from 'src/assets/svg/SvgLocation.svg';
import './empty-spots-ssr.scss';

const CookieService = require('../../services/cookie.service');

const BlurSignupModal = loadable(() => import('../modal-blur-signup'));

const b = bemCn('empty-spots-ssr');

const EmptySpotsSSR = () => {
    const [isBlurTest, setIsBlurTest] = useState(null);

    const handleAlerts = () => {
        CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, RouteFormatter.newSpotAlerts(), { expires: 1 });
        setIsBlurTest(true);
    };

    return (
        <div className={b()}>
            <p>
                <SvgLocation width={64} height={64} />
            </p>
            <h3 className="snif-m2 snif-semibold mt-2 mb-2">Not seeing spots you're looking for?</h3>
            <p className="snif-p mb-2">Don't worry we can notify you when new spots are added that match this search</p>
            <SniffButton color="secondary" size="sm" onClick={handleAlerts}>
                Manage new spot alerts
            </SniffButton>
            <BlurSignupModal {...{ isBlurTest, setIsBlurTest }} />
        </div>
    );
};

export default EmptySpotsSSR;
